import React, { useCallback, memo, useContext } from 'react';
import { ButtonColor, FuncType } from '../../button/enum';
import { Size } from '../../core/enum';
import Button from '../../button/Button';
import TableContext from '../TableContext';
const CustomizationColumnHeader = function CustomizationColumnHeader(props) {
    const { onHeaderClick, customizedBtn } = props;
    const context = useContext(TableContext);
    const openCustomizationModal = useCallback(() => onHeaderClick(context), [context, onHeaderClick]);
    return (React.createElement(Button, { color: customizedBtn ? ButtonColor.primary : ButtonColor.default, funcType: FuncType.flat, size: Size.small, icon: customizedBtn ? "settings-o" : "predefine", onClick: openCustomizationModal }));
};
CustomizationColumnHeader.displayName = 'CustomizationColumnHeader';
export default memo(CustomizationColumnHeader);
